import { ContentHeader } from "../../components";
import { Form, Button, Input, Row, Col, Table, Space, Switch, Tag, Tooltip } from 'antd';
import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, SearchOutlined, CheckOutlined, CloseOutlined} from '@ant-design/icons';
import { useEffect, useState } from "react";
import Column from 'antd/es/table/Column';
import { ThongBaoLoginResponse } from "../../models/danhmuc/DanhMuc";
import { layDanhSachThongBaoLogin, luuThongBaoLogin, xoaThongBaoLogin } from "@app/services/danhmuc";
import ModalTextForm from "@app/components/modal/ModalTextForm";
import { toast } from "react-toastify";
import { validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import { ThongBaoChungResponse } from "../../models/thongbaochung/ThongBaoChung";
import { searchLength } from "../../constants";

const QuanLyThongBaoLogin = () => {
    const [data, setData] = useState<Array<ThongBaoLoginResponse>>([]);
    const [page, setPage] = useState(1);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [stateTT, setStateTT] = useState<number>(1);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const setFormDetailModal = (value: ThongBaoLoginResponse | null) => {
        form.setFieldsValue({
            "id": value?.id || 0,
            "noiDung": value?.noiDung || "",
            "trangThai": value?.trangThai || 0
        });
        setShowModalChiTiet(true);
    }

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            let rs = await layDanhSachThongBaoLogin();
            setData(rs);
            setIsLoadingTable(false);
        } catch (error: any) {
        };
    }

    const onDelete = async () => {
        try {
            setIsLoadingBtn(true);
            await xoaThongBaoLogin(idXoa);
            toast.success('Xoá thông báo thành công!');

            // Tính toán số trang mới sau khi xóa
            const totalRecords = data.length - 1; // Số lượng bản ghi sau khi xóa
            let newPage = page;

            if (newPage > Math.ceil(totalRecords / searchLength)) {
                // Nếu trang hiện tại lớn hơn số trang mới tối đa
                newPage = Math.ceil(totalRecords / searchLength);
            }

            setPage(newPage);
            
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá thông báo không thành công!');
        }
        setIdXoa(0);
        setReloadPage(true);
        setIsLoadingBtn(false);
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            await luuThongBaoLogin(values);
            setShowModalChiTiet(false);
            toast.success('Lưu thông báo thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
    };

    useEffect(() => {
        if (reloadPage) {
            layDuLieu();
            setReloadPage(false);
            setStateTT(1);
        }
    }, [reloadPage]);

    return (<section>
        <ContentHeader title="Quản lý Thông báo Màn hình Đăng Nhập" />
        {idXoa > 0 && <ModalTextForm show={idXoa > 0}
            title="Xoá thông báo"
            handleClose={() => setIdXoa(0)}
            handleSave={onDelete}>
            Xác nhận xóa thông báo đang chọn đang chọn
        </ModalTextForm>}
        {showModalChiTiet && <ModalTextForm title="Quản lý thông báo"
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Row gutter={16}>
                    <Col span={18}>
                        <Form.Item
                            label="Nội dung thông báo"
                            name="noiDung"
                            key="noiDung"
                            rules={[{ required: true, message: 'Vui lòng nhập nội dung thông báo' }]}
                        >
                            <Input.TextArea rows={1} placeholder="Nhập nội dung thông báo" />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span="6">
                        <Form.Item name="trangThai" label="Trạng thái" key="trangThai">
                            <div>
                                <Tooltip title={stateTT ? "Hoạt động" : "Không hoạt động"} placement="bottomLeft">
                                    <Switch
                                        checked={stateTT === 1 ? true:false}
                                        checkedChildren={<CheckOutlined rev="" />}
                                        unCheckedChildren={<CloseOutlined rev="" />}
                                        onChange={(e) => {
                                            form.setFieldsValue({ trangThai: e ? 1 : 0 });
                                            setStateTT(e ? 1 : 0);
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập nội dung để tìm kiếm" onChange={(e) =>{setPage(1); setTuKhoa(e.target.value)}} />
            </Col>
            <Col span={16}>
                <Button
                    className="hrm-btn hrm-btn-warning float-right"
                    onClick={() => {
                        setFormDetailModal({
                            "id": 0,
                            "noiDung": "",
                            "trangThai": 1
                        });
                        setStateTT(1);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: ThongBaoChungResponse) =>
                                    (record.noiDung.toLowerCase().includes(tuKhoa.toLowerCase()))
                                )}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                            >
                                <Column
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength + index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column width="80%" title="Nội dung thông báo" dataIndex="noiDung" key="noiDung" />
                                <Column
                                    width="15%"
                                    title="Trạng thái"
                                    key="trangThai"
                                    render={(value: ThongBaoLoginResponse) => (
                                        <Tag color={value.trangThai === 1 ? 'green' : 'red'}>
                                            {value.trangThai === 1 ? 'Đang hoạt động' : 'Không hoạt động'}
                                        </Tag>
                                    )}
                                />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Space>
                                            <Button type="primary" size={"small"} title="Sửa"
                                                icon=<EditOutlined rev="" />
                                                onClick={() => { setFormDetailModal(value); setStateTT(value.trangThai); }}
                                            >
                                                Sửa
                                            </Button>
                                            <Button type="primary" danger size={"small"} title="Xóa"
                                                onClick={() => { setIdXoa(value.id) }}
                                                icon=<DeleteOutlined rev="" />
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default QuanLyThongBaoLogin;